"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _reactComponents = require("@ui-propulsion/react-components");
var useStyles = (0, _reactComponents.makeStylesPropulsion)(function (theme) {
  var palette = theme.palette,
    typography = theme.typography;
  var fontFamilyBold = typography.fontFamilyBold,
    fontFamilyRegular = typography.fontFamilyRegular,
    pxToRem = typography.pxToRem;
  return {
    root: {
      fontFamily: fontFamilyRegular,
      color: palette.denim[500]
    },
    title: {
      fontFamily: fontFamilyBold,
      fontSize: pxToRem(18),
      lineHeight: pxToRem(22),
      margin: "".concat(pxToRem(24), " 0 ").concat(pxToRem(20), " 0")
    },
    fieldWrap: {
      marginBottom: pxToRem(24)
    },
    fieldWrapLastName: {
      marginBottom: pxToRem(32)
    },
    fieldWrapFirstName: {
      marginBottom: pxToRem(24)
    }
  };
}, {
  name: 'PlaidVerifyName'
});
exports.useStyles = useStyles;
